import Styles from './SearchSource.scss';

import Template from './SearchSource.hbs';
import Util from 'util/util';

var Source = BaseView.extend({

    events: {
        click: 'onClick'
    },

    initialize(options) {

        // capitalize only first character of string
        options.concept = Util.capitalizeFirstLetter(options.concept)

        this.setElement(Template({
            Styles,
            concept: options.concept,
            title: Util.renderContentSafely(this.model.get('source_title')),
            location: this.model.get('location')
        }));

        this.theory = options.theory;
    },

    /**
     * onClick - onClick on search result
     *
     */
    onClick() {

        // get Theory Branch id from model
        var theoryBranchId = this.model.get('location')[1].id;

        // get source id from model and preselected it
        this.theory.preselectedSourceId = this.model.get('source_id');

        this.theory.preselectedTheoryBranch = theoryBranchId;

        // open Secondary Branch
        this.theory.openSecondaryBranchId(theoryBranchId, true);
    }

});

export default Source;
